module.exports = __webpack_public_path__ + "img/39.7d7d1257.jpg";